export const B4UPLUS_PATH = 'foruplus';

const base = `/${B4UPLUS_PATH}`;

export const B4UPLUS_ROUTES = {
    LANDING: base,
    MANAGE_PLAN: `${base}/manage/plan`,
    MANAGE_CHANGE: `${base}/manage/change`,
    MANAGE_CANCEL_PLAN: `${base}/manage/cancel-plan`,
    MANAGE_UPDATE_PAYMENT: `${base}/manage/update-payment`,
    MANAGE_FAQ: `${base}/manage/foruplus-faq`,
    MANAGE_DISCOUNT: `${base}/manage/discount`
} as const;
